import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { DemoRequestsPage } from '@/features/agency';
import { formatDocumentTitle } from '@/lib/document-title';

/**
 * `?id=` opens that request's drawer — the target of the "Open in agency workspace" link in the
 * team notification email. Every agency member may view it (the parent layout gates non-agency users).
 */
type DemoRequestsSearchParams = {
  id?: string;
};

export const Route = createFileRoute('/_auth/agency/demo-requests')({
  validateSearch: (search: Record<string, unknown>): DemoRequestsSearchParams => ({
    ...(typeof search.id === 'string' && search.id.trim() ? { id: search.id.trim() } : {}),
  }),
  component: DemoRequestsRoute,
});

function DemoRequestsRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Demo Requests')}</title>
      </Helmet>
      <DemoRequestsPage />
    </>
  );
}
